import React from 'react';
import { View } from 'react-native';
import { styles } from './LookupDropdownItem.styles';
import { filterGroupTestID } from 'src/helpers/testIDs.helper';
import i18n from 'src/app/i18n';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { ProductOptionChoiceInstance } from 'src/store/_models/productOptionChoice';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { brand } from 'src/theme/colors';
import { getToolOptionChoiceTitleI18nKey } from 'src/_shared/utils/getI18nKeys';
import { Background } from 'src/theme-v2/background';
import { PressableHovered } from 'src/editor-v3/components/pressable-hovered/PressableHovered';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { INSET_FOCUS_RING } from 'src/theme-v2/focus';

interface LookupDropdownItemProps {
  item: ProductOptionChoiceInstance;
  onPress: (item: ProductOptionChoiceInstance) => void;
  showPrice?: boolean;
  focusOrder?: number;
}

export const LookupDropdownItem: React.FC<LookupDropdownItemProps> = ({
  item,
  onPress,
  showPrice,
  focusOrder = 0,
}) => {
  const title = getToolOptionChoiceTitleI18nKey(
    item.productFamily,
    item.productOptionCode,
    item.productOptionChoiceCode,
    item.choiceDetails,
  );
  return (
    <PressableHovered
      style={({ pressed, hovered }) => [
        styles.dropdownItem,
        item.selected && { backgroundColor: Background.BackgroundColorSelected },
        hovered && styles.dropdownItemHovered,
        pressed && styles.dropdownItemPressed,
      ]}
      onPress={() => onPress(item)}
      testID={filterGroupTestID(item.productOptionCode)}
      accessibilityLabel={i18n.t(title)}
      accessibilityRole="radio"
      accessibilityState={{ checked: item.selected }}
      focusGroup={FocusGroups.LOOKUP_CHOICE}
      focusOrder={focusOrder}
      focusStyle={INSET_FOCUS_RING}
    >
      <View style={styles.dropdownItemWrapper}>
        <View style={styles.dropdownItemIcon}>
          <TextLato style={item.selected ? styles.dropdownItemTextSelected : styles.dropdownItemText}>
            {i18n.t(title)}
          </TextLato>
          {showPrice && (
            <TextLato style={item.selected ? styles.dropdownItemCountSelected : styles.dropdownItemCount}>
              {getFormattedPrice({ price: item.price })}
            </TextLato>
          )}
        </View>
        {item.selected && (
          <View style={styles.checkIcon}>
            <Icon name={ICON_NAMES.Check} color={brand.main.water} />
          </View>
        )}
      </View>
    </PressableHovered>
  );
};
